import { Component, OnInit, Input, HostBinding, SimpleChanges, OnChanges, ElementRef } from '@angular/core';

@Component({
  selector: 'progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.css']
})
export class ProgressBarComponent implements OnInit {

  @Input() value: number = 0;
  @Input() type: 'success' | 'warning' | 'error' | 'dynamic' = 'dynamic';
  @Input() max: number = 100;
  modeIsDynamic: boolean = false;
  warningPct: number = 80;
  errorPct: number = 90;

  constructor(private eleRef: ElementRef) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.value) {
      if (this.type === "dynamic") {
        this.resetClasses();
        this.setDynamicClass();
      }
    }
  }

  resetClasses() {
    this.eleRef.nativeElement.classList.remove("success");
    this.eleRef.nativeElement.classList.remove("warning");
    this.eleRef.nativeElement.classList.remove("error");
  }

  setDynamicClass() {
    var pct = this.getPct();

    if (pct >= this.errorPct) {
      this.eleRef.nativeElement.classList.add("error");
    }
    else if (pct >= this.warningPct) {
      this.eleRef.nativeElement.classList.add("warning");
    }
    else {
      this.eleRef.nativeElement.classList.add("success");
    }
  }

  getPct(): number {
    return this.value ? Number(((Number(this.value) / Number(this.max)) * 100).toFixed(0)) : 0;
  }


}
